import React from 'react';
import { useRecoilValue } from 'recoil';
import { CardBody } from '../../components/CardBody';
import { CardHeader } from '../../components/CardHeader';

import { allProductsState } from '../../recoil/atoms';
import { assetPathFn } from '../../util';
import { ShopNowCardFooter } from '../HomeLander/HomeLanderMobile';
import { HeroCallout } from '../HeroCallout';
import { WistiaPanel } from '../../components/WistiaPanel';
import { NewsIcons } from '../../product_detail/components/NewsIcons';
import { ShopAllColors } from '../components/ShopAllColors';
import { ProductFeatures } from '../components/ProductFeatures';
import { LanderTopHero } from '../components/LanderTopHero';
import { ProductHandle } from '../../enums/ProductHandle.enum';
import { CardFooter } from '../../components/CardFooter';
import styles from './LiftWearTankBodysuitLanderMobile.module.scss';
import { useLanderControls } from '../LanderContext';
import { Button } from '../../root/components/buttons/Button';

export const LiftWearTankBodysuitLanderMobile: React.FC = () => {
  const allProducts = useRecoilValue(allProductsState);
  const { scrollToProductSection } = useLanderControls();

  const wistiaVideoId = 'txjj1yry1r';
  const padding = { padding: '145.0% 0 0 0' };

  return (
    <>
      <CardBody>
        <LanderTopHero
          heroImage={'mobile-liftwear-tank-bodysuit-lander-top-hero-1.jpg'}
          title={'Tank Bodysuit'}
          subTitle={`The perfect shaping bodysuit has arrived.`}
          backgroundColor={'#E2E2E2'}
        >
          <HeroCallout
            orderIndex={0}
            label={
              <>
                Anti-back
                <br />
                buldge
              </>
            }
            titleStyles={{ lineHeight: '22px' }}
            inlineStyles={{
              mobile: {
                right: `66%`,
                top: `59%`,
                flexDirection: 'row-reverse',
                alignItems: 'flex-start',
              },
            }}
          />
          <HeroCallout
            orderIndex={1}
            label={
              <>
                Underwire
                <br />
                -free lift
              </>
            }
            titleStyles={{ lineHeight: '22px', textAlign: 'left' }}
            inlineStyles={{
              mobile: {
                left: `70%`,
                top: `52%`,
                flexDirection: 'row-reverse',
              },
            }}
          />
          <HeroCallout
            orderIndex={2}
            label={
              <>
                Targeted X <br />
                Compression
              </>
            }
            titleStyles={{ lineHeight: '22px', marginTop: 8, textAlign: 'center' }}
            inlineStyles={{
              mobile: {
                left: `22%`,
                top: `70%`,
                flexDirection: 'column-reverse',
              },
            }}
          />
        </LanderTopHero>
      </CardBody>
      <ShopNowCardFooter onClick={scrollToProductSection} />
      <CardHeader />
      <CardBody>
        <NewsIcons />
        <ProductFeatures
          features={[
            {
              imgName: 'feature-lwtb-desktop-1.jpg',
              title: 'Underwire-free lift',
              description: 'Bonding at the cradle lifts your chest for a supportive, comfortable fit.',
            },
            {
              imgName: 'feature-lwtb-desktop-2.jpg',
              title: 'Targeted smoothing',
              description: 'Targeted X-shaped panel hugs your midsection for extra waist shaping.',
            },
            {
              imgName: 'feature-lwtb-desktop-3.jpg',
              title: 'Stays tucked in',
              description: 'The garment is anchored at the gusset to prevent it from rolling up.',
            },
          ]}
        />
        <div className={styles.fitsPefectPanel}>
          <img src={assetPathFn('liftwear-tank-bodysuit-perfect-fit-mobile.jpg')} alt="fits perfectly from xs-3x" />
          <div>
            <div className={styles.fitsPerfectText}>Fits perfectly from XS-3X.</div>
            <Button text="Shop now" onClick={scrollToProductSection} buttonType="transparent" size="small" />
          </div>
        </div>
        <WistiaPanel videoId={wistiaVideoId} responsivePadding={padding} />
        <ShopAllColors product={allProducts[ProductHandle.TankBodysuit]} />
      </CardBody>
      <CardFooter />
    </>
  );
};

export default LiftWearTankBodysuitLanderMobile;
